export const fetchImageAsDataUrl = async url => {
  const response = await window.fetch(url);
  const xml = await response.text();
  return xml;
};
